

































































import {Vue, Component, Prop} from 'vue-property-decorator'

export type BridgeToken = {
  hash: string
  decimals: number
  chainDecimals?: number
}

export type BridgeTokenOption = {
  symbol: string
  icon: string
  minAmount: string
  n3: BridgeToken
  x: BridgeToken
}

@Component({})
export default class BridgeTokenSelection extends Vue {
  @Prop({type: Array, required: true}) tokenOptions!: BridgeTokenOption[]
  @Prop({required: true}) selectedToken!: BridgeTokenOption

  isDropdownOpen = false

  async handleSelectToken(token: BridgeTokenOption) {
    this.isDropdownOpen = false

    this.$emit('token-selected', token)
  }

  setIsDropdownOpen() {
    this.isDropdownOpen = !this.isDropdownOpen
  }
}
